import Client, { jwtPlugin } from '@synapsestudios/fetch-client';
import store from 'store2';
import config from '../config';

const client = new Client({ url: '/api' });

client.addPlugin(jwtPlugin);
client.setJwtTokenGetter(() => store.get(config.auth.idTokenKey));

export default client;



// WEBPACK FOOTER //
// ./src/common/client.js